<div id="_messages-HEADER_" class="px-2 w-full font-bold flex text-1.5 iBTTiny:text-center ism-green lanPixel2xl:text-left overlay-dark-40">{{ channel }} Messages</div>

<div id="_messages-CENTER_" class="px-2 my-1 text-1.25 w-full flex items-stretch">
  @if (displayUsers || displayRaces || displayNegotiations || displayEncounters) {
    <div class="w-fit border-r-2">
      @if (displayUsers) {
        <div class="flex-auto">
          <ul cdkListbox class="m-0 p-0 flex flex-col ism-white" [(ngModel)]="selectedUserId">
            @for (user of users() | orderBy: "first"; track user._id) {
              <li [cdkOption]="user._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: user._id === selectedUserId() }" (click)="getUserMessages(user._id)">
                {{ user.first + " " + user.last }}
              </li>
            }
          </ul>
        </div>
      }

      @if (displayRaces) {
        <div class="flex-auto">
          @if (racesToDisplay.length > 0) {
            <ul cdkListbox class="p-1 flex flex-col ism-white" [(ngModel)]="selectedRaceId">
              @for (race of racesToDisplay; track race._id) {
                <li [cdkOption]="race._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: race._id === selectedRaceId() }" (click)="getRaceMessages(race._id)">
                  {{ racesById[race._id].name }}
                </li>
              }
            </ul>
          }
          <!-- -->
          @else {
            <div class="p-1 whitespace-nowrap ism-white">No races</div>
          }
        </div>
      }

      @if (displayNegotiations) {
        <div class="flex-auto ism-white">
          <div class="p-1 whitespace-nowrap">
            <input type="checkbox" [(ngModel)]="showOld" />
            <span class="text-1">Completed Negotiations</span>
          </div>
          @if (currentNegotiations() && currentNegotiations().length) {
            <ul cdkListbox class="p-1 flex flex-col" [(ngModel)]="selectedNegotiationId">
              @for (negotiation of currentNegotiations() | orderBy: "turnStrategic"; track negotiation._id) {
                <li [cdkOption]="negotiation._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: negotiation._id === selectedNegotiationId() }" (click)="getNegotiationMessages(negotiation._id)">
                  {{ "turn: " + negotiation.turnStrategic + ", day: " + negotiation.pulseStrategic }}
                </li>
              }
            </ul>
          }
          <!-- -->
          @else {
            <div class="p-1 text-1 ism-white">No Current Negotiations</div>
          }
          @if (showOld()) {
            @if (oldNegotiations().length) {
              <ul cdkListbox class="p-1 flex flex-col ism-white" [(ngModel)]="selectedNegotiationId">
                @for (oldNegotiation of oldNegotiations() | orderBy: "turnStrategic"; track oldNegotiation._id) {
                  <li [cdkOption]="oldNegotiation._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: oldNegotiation._id === selectedNegotiationId() }" (click)="getNegotiationMessages(oldNegotiation._id)">
                    {{ "turn: " + oldNegotiation.turnStrategic + ", day: " + oldNegotiation.pulseStrategic }}
                  </li>
                }
              </ul>
            }
            <!-- -->
            @else {
              <div class="p-1 text-1 ism-white">No Old Negotiations</div>
            }
          }
        </div>
      }

      @if (displayEncounters) {
        <div class="flex-auto ism-white">
          <div class="p-1 whitespace-nowrap">
            <input type="checkbox" [(ngModel)]="showOld" />
            <span class="pr-1 text-1">Completed Encounters</span>
          </div>
          @if (currentEncounters() && currentEncounters().length) {
            <ul cdkListbox class="p-1 flex flex-col ism-white" [(ngModel)]="selectedEncounterId">
              @for (encounter of currentEncounters() | orderBy: "turnStrategic"; track encounter._id) {
                <li [cdkOption]="encounter._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: encounter._id === selectedEncounterId() }" (click)="getEncounterMessages(encounter._id)">
                  {{ "Name: " + encounter.name + ", Turn: " + encounter.turnStrategic + ", Day: " + encounter.pulseStrategic }}
                </li>
              }
            </ul>
          }
          <!-- -->
          @else {
            <div class="p-1 text-1 ism-white">No Current Encounters</div>
          }
          @if (showOld()) {
            @if (oldEncounters().length) {
              <ul cdkListbox class="p-1 flex flex-col ism-white" [(ngModel)]="selectedEncounterId">
                @for (oldEncounter of currentEncounters() | orderBy: "turnStrategic"; track oldEncounter._id) {
                  <li [cdkOption]="oldEncounter._id" class="m-0 px-3 whitespace-nowrap ism-white option-bw" [ngClass]="{ selected: oldEncounter._id === selectedEncounterId() }" (click)="getEncounterMessages(oldEncounter._id)">
                    {{ "Turn: " + oldEncounter.turnStrategic + ", Day: " + oldEncounter.pulseStrategic + ", Name: " + oldEncounter.name }}
                  </li>
                }
              </ul>
            }
            <!-- -->
            @else {
              <div class="p-1 text-1 ism-white">No Old Encounters</div>
            }
          }
        </div>
      }
    </div>
  }

  <div class="w-full flex flex-col overlay-dark-30 ism-white">
    @if (displayMessages) {
      <div class="flex flex-col">
        <div class="flex justify-end">
          @if (channel === "Notification") {
            <div>
              Priority:
              <button class="btn" [ngClass]="{ selected: priority() === 0 }" (click)="priority.set(0)">All</button>
              <button class="btn" [ngClass]="{ selected: priority() === 1 }" (click)="priority.set(1)">1</button>
              <button class="btn" [ngClass]="{ selected: priority() === 2 }" (click)="priority.set(2)">2</button>
              <button class="btn" [ngClass]="{ selected: priority() === 3 }" (click)="priority.set(3)">3</button>
            </div>
          }
          @if (getMore) {
            <div>Get Older Messages - coming soon</div>
          }
        </div>
      </div>
    }

    <div class="w-full flex flex-col">
      @for (message of filteredMessages() | orderBy: "dateCreated"; track message._id) {
        <div class="p-1 w-full flex flex-row ism-white">
          <!-- PREFIX -->
          <div class="text-left whitespace-nowrap flex flex-row">
            @if (channel === "Notification") {
              @if (message.hour >= 0) {
                <div style="width: 80px" class="pt-1 text-left whitespace-nowrap">Day: {{ (message.hour - 12) / 24 + 1 | number: "1.0-0" }},&nbsp;</div>
                <div style="width: 100px" class="pt-1 text-left whitespace-nowrap">Hour: {{ message.hour % 24 | number: "1.0-0" }}</div>
              }
            }
            <!-- -->
            @else if (message.userIdFrom && !message.raceIdFrom) {
              <div class="p-1 ism-white">
                {{ usersById[message.userIdFrom]?.first + " " + usersById[message.userIdFrom]?.last + ": " }}
              </div>
            }
            <!-- -->
            @else if (message.raceIdFrom && message.channel != "Notification") {
              <div class="text-left ism-white">
                {{ racesById[message.raceIdFrom]?.name + ": " }}
              </div>
            }
          </div>
          <!-- MESSAGE -->
          <div class="pt-1 w-full text-left ism-white">{{ message.message }}</div>
        </div>
      }
    </div>
  </div>
</div>

@if (channel != "Notification" && canPost) {
  <hr class="w-full border border-yellow-400" />
  <div>
    <label class="text-right ism-white">Message: </label>
  </div>
  <div class="pt-1 flex flex-row ism-white">
    <input class="text-black inputText" [(ngModel)]="messageText" required />
    <button class="btn btn-default" type="button" (click)="addMessage()">Send</button>
  </div>
}
